import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export default function NotFoundPage() {
  useEffect(() => { document.title = "Pagina non trovata | Progetto HOSPITALITY"; }, []);
  return (
    <>
      <Header />
      <main className="bg-warm pt-32 lg:pt-40 pb-24 min-h-[70vh]" data-testid="not-found-page">
        <div className="container-ph max-w-2xl">
          <span className="gold-line mb-5" />
          <p className="eyebrow">Errore 404</p>
          <h1 className="h-section mt-3">Pagina non trovata.</h1>
          <p className="mt-5 text-base sm:text-lg text-ink/75 leading-relaxed">La pagina che stai cercando non esiste o è stata spostata.</p>
          <Link to="/" className="btn-primary mt-9" data-testid="not-found-home-link">TORNA ALLA HOME</Link>
        </div>
      </main>
      <Footer />
    </>
  );
}
